import React, { useState, useEffect } from "react";
import { Button, Label, Confirm, Icon } from "semantic-ui-react";
import { useParams, Link } from "react-router-dom";
import { PostItemDetail, AnswerList } from "../../../components/Admin/Forum";
import { Post as PostAPI } from "../../../api";
import { useAuth } from "../../../hooks";
import { socket } from "../../../utils";
import "./Post.scss";

const postController = new PostAPI();

export function Post() {
  const { postId } = useParams();
  const { accessToken } = useAuth();
  const [post, setPost] = useState(null);
  const [action, setAction] = useState(null);
  const [reload, setReload] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        const response = await postController.getPostById(accessToken, postId);
        setPost(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [postId, reload, accessToken]);

  useEffect(() => {
    const handleAnswerCreated = ({ answer, postId: newPostId }) => {
      if (String(newPostId) !== String(postId)) return;
      setPost((prev) =>
        prev?.id ? { ...prev, Answers: [...(prev.Answers || []), answer] } : prev
      );
    };
    socket.on("answerCreated", handleAnswerCreated);
    return () => {
      socket.off("answerCreated", handleAnswerCreated);
    };
  }, [postId]);

  const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return (
          <Label className="post__status-label" size="large" color="yellow">
            <Icon name="clock" />
          </Label>
        );
      case 1:
        return (
          <Label className="post__status-label" size="large" color="blue">
            <Icon name="eye" />
          </Label>
        );
      case 2:
        return (
          <Label className="post__status-label" size="large" color="secondary">
            <Icon name="eye slash" />
          </Label>
        );
      default:
        return null;
    }
  };

  const handlePostAction = (actionType, message) => {
    setAction(actionType);
    setConfirmMessage(message);
    onOpenCloseConfirm();
  };

  const onPostAction = async () => {
    try {
      if (action === "approve") {
        await postController.updatePost(accessToken, post.id, { status: 1 });
      } else if (action === "reject") {
        await postController.updatePost(accessToken, post.id, { status: 2 });
      } else if (action === "resolve") {
        await postController.updatePost(accessToken, post.id, {
          solved: true,
        });
      }
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="post-page">
        <div className="post-page__header">
          <Button
            className="post-page__header-back"
            color="grey"
            as={Link}
            to="/admin/forum"
          >
            Volver
          </Button>
          <h1 className="post-page__header-title">Detalle de la publicación</h1>
        </div>
        <PostItemDetail
          post={post}
          getStatusLabel={getStatusLabel}
          onAction={handlePostAction}
        />
        <AnswerList
          post={post}
          answers={post?.Answers}
          getStatusLabel={getStatusLabel}
          onReload={onReload}
        />
        <Confirm
          confirmButton="Aceptar"
          cancelButton="Cancelar"
          open={showConfirm}
          onCancel={onOpenCloseConfirm}
          onConfirm={onPostAction}
          content={confirmMessage}
          size="mini"
        />
      </div>
    </>
  );
}
